import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Heart, Shield } from 'lucide-react';
import { Button } from '../../components/ui/button';

const ExencionResponsabilidadPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Cláusula de Exención de Responsabilidad Deportiva</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <div className="p-6 bg-primary/10 border border-primary/20 rounded-lg mb-8">
              <div className="flex items-center gap-3 mb-4">
                <Heart className="h-6 w-6 text-primary" />
                <h2 className="text-xl font-semibold text-white m-0">Declaración del Usuario</h2>
              </div>
              <p className="text-zinc-300">
                El usuario declara y acepta que:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4 text-zinc-300">
                <li>Conoce y asume los riesgos inherentes a la práctica de ejercicio físico.</li>
                <li>Consultará con un médico o profesional sanitario en caso de duda sobre su estado de salud o aptitud para realizar los entrenamientos propuestos.</li>
                <li>Adaptará la intensidad y tipo de ejercicio a su condición física real y a sus limitaciones personales.</li>
                <li>Utilizará la plataforma bajo su propia responsabilidad.</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-3 mb-4">
              <Shield className="h-6 w-6 text-blue-400" />
              <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 flex-1">
                Naturaleza del Servicio
              </h2>
            </div>
            <div className="p-4 bg-blue-900/20 border border-blue-800/30 rounded-lg">
              <p className="text-blue-300 font-semibold">
                GUARDIÁNSFIT no es un servicio sanitario ni presta diagnóstico médico, tratamiento clínico o prescripción terapéutica.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Limitación de Responsabilidad
            </h2>
            <p>
              En la medida permitida por la normativa aplicable, GUARDIÁNSFIT no será responsable de:
            </p>
            <ul className="list-disc pl-6 space-y-3 mt-4">
              <li>Lesiones, daños o perjuicios derivados de la realización de planes de ejercicio o actividades sugeridas a través de la plataforma.</li>
              <li>Efectos adversos derivados de cambios en los hábitos de actividad física o estilo de vida.</li>
              <li>Consecuencias derivadas de datos falsos, incompletos o inexactos introducidos por el propio usuario.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Carácter Educativo
            </h2>
            <div className="p-4 bg-zinc-900/50 rounded-lg">
              <p>
                El contenido de GUARDIÁNSFIT tiene carácter educativo e informativo y <strong className="text-zinc-200">no sustituye 
                la consulta con profesionales de la salud</strong>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Recomendación
            </h2>
            <div className="p-6 bg-gradient-to-r from-primary/10 to-blue-900/10 border border-primary/20 rounded-lg">
              <p className="text-lg">
                Antes de comenzar cualquier programa de entrenamiento, te recomendamos encarecidamente que 
                consultes con tu médico, especialmente si:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Tienes alguna condición médica preexistente</li>
                <li>Llevas un tiempo prolongado sin realizar actividad física</li>
                <li>Tienes más de 40 años y no has realizado ejercicio regularmente</li>
                <li>Tienes dudas sobre tu capacidad para realizar ciertos ejercicios</li>
              </ul>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExencionResponsabilidadPage;
